import React, { useEffect, useState, useContext } from 'react'
import { language } from '../../App'
import LightboxGrid from '../../components/LightboxGrid/LightboxGrid'
import './StagesBacklots.scss'
import { Fetcher } from '../../helpers/api/Fetcher'
import H1 from '../../components/Fonts/H1/H1';
import { Col, Container, Row } from 'react-bootstrap';

const StagesBacklots = () => {
  const { currentLanguage } = useContext(language)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    const fecthApi = async () => {
      const URL = `https://beta.haromstudio.hu/scriptedprod/wp-json/wp/v2/pages/601?_embed&acf_format=standard`;
      const res = await Fetcher({ URL, setIsLoading })
      
      setData(res)
      
      setIsLoading(false)
    }
    
    fecthApi()
  }, [currentLanguage])

  if (!isLoading && data.acf) {
  return (
    <main className='service-production--stages-and-backlots'>
        <Container>
          <Row className='mt-4'>
            <Col xs={12} md={6}>
              <div className='block block-site-title mt-2'>
                <H1 text='Stages' />
              </div>
              <div className=''>
                {!isLoading && <LightboxGrid data={data.acf.stages}/>}
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className='block block-site-title mt-2'>
                <H1 text='Backlots' />
              </div>
              <div className=''>
                {!isLoading && <LightboxGrid data={data.acf.backlots}/>}
              </div>
            </Col>
            <Col xs={12}>
              <div className='mt-5 mb-1 text-white text-center' dangerouslySetInnerHTML={{ __html: data.content.rendered }}></div>
            </Col>
          </Row>
        </Container>
    </main>
  )
  } else {
    return (
      <main className='body'></main>
    )
  }
}

export default StagesBacklots